import { AppContext } from 'context/ContextProvider';
import { useContext, useEffect, useMemo, useState } from 'react';
import { useGetCheckoutDotComCards } from 'views/Accounts/hooks/useGetCheckoutDotComCards';
import { selectCheckoutDotComCards } from 'views/Accounts/utils';
import { ACCEPTED_PAYMENT_METHODS } from 'views/Accounts/constants';
import { CardType } from 'types/commonTypes';
import { CashBalanceResponse } from '../views/shared/types';
import { useFetchCashBalance } from '../views/shared/hooks/useFetchCashBalance';

const useMetadata = () => {
  const {
    state: {
      settings: { email, fullname },
    },
    formatter,
  } = useContext(AppContext);
  const { data: cardsBin } = useGetCheckoutDotComCards();
  const _cards = selectCheckoutDotComCards(cardsBin);

  const validCards: (CardType | null)[] = _cards
    .slice()
    .sort((a) => (a.defaultMitFlag ? -1 : 1))
    .map((card) =>
      ACCEPTED_PAYMENT_METHODS.find((x) => x.toLocaleLowerCase() === (card?.scheme || '').toLocaleLowerCase())
        ? {
            id: card.instrumentId,
            name: card.clientName,
            last4: card.last4,
            expiryDate: card.expiry,
            defaultMitFlag: card.defaultMitFlag,
            scheme: card.scheme,
          }
        : null,
    );

  const [userName, setUserName] = useState('');
  const { data: cashBalanceResponse, isLoading: loadingTotalInvested } = useFetchCashBalance();

  const availableBalance = useMemo(() => {
    const response = cashBalanceResponse as CashBalanceResponse;
    if (!response || !response.balances) return '';

    return formatter.format(response.todayInvestment);
  }, [cashBalanceResponse, formatter]);

  useEffect(() => {
    if (fullname !== userName) setUserName(`- ${fullname}`);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fullname]);

  return {
    email,
    fullname,
    userName,
    availableBalance,
    loadingTotalInvested,
    defaultCard: validCards.filter((x) => x?.defaultMitFlag)?.[0],
    allValidCards: validCards,
  };
};

export default useMetadata;
